import type { PdfOptions } from "@/src/lib/pdf/print-document";
import {
  PDF_CODE_THEMES,
  type PdfResolvedCodeTheme,
} from "@/src/lib/pdf/print-document/code-themes";
import { PDF_THEMES } from "@/src/lib/pdf/print-document/themes";
import { SUPPORTED_FONTS } from "@/src/lib/pdf/fonts";

export const paperSizeLabels = {
  a4: "A4",
  letter: "Letter",
} satisfies Record<PdfOptions["paperSize"], string>;

export const orientationLabels = {
  portrait: "Portrait",
  landscape: "Landscape",
} satisfies Record<PdfOptions["orientation"], string>;

export const marginLabels = {
  narrow: "narrow margins",
  normal: "normal margins",
  wide: "wide margins",
} satisfies Record<PdfOptions["margins"], string>;

export const marginSummaryLabels = {
  narrow: "Narrow margins",
  normal: "Normal margins",
  wide: "Wide margins",
} satisfies Record<PdfOptions["margins"], string>;

export const fontLabels = Object.fromEntries(
  SUPPORTED_FONTS.map((font) => [font.key, font.label]),
) as Record<PdfOptions["fontFamily"], string>;

export const themeLabels = Object.fromEntries(
  PDF_THEMES.map((theme) => [theme.id, theme.label]),
) as Record<PdfOptions["theme"], string>;

export const codeThemeLabels = {
  auto: "Auto",
  ...(Object.fromEntries(
    PDF_CODE_THEMES.map((theme) => [theme.id, theme.label]),
  ) as Record<PdfResolvedCodeTheme, string>),
} satisfies Record<PdfOptions["codeTheme"], string>;

export const diagramThemeLabels = {
  auto: "Auto",
  ...themeLabels,
} satisfies Record<PdfOptions["diagramTheme"], string>;
